const isValidCountryCode = (code: string | null | undefined): code is string =>
    Boolean(code && code.length === 2);

async function fetchFromCloudflareTrace(): Promise<string | null> {
    try {
        const res = await fetch('https://www.cloudflare.com/cdn-cgi/trace', {
            cache: 'no-store'
        });
        if (!res.ok) {
            return null;
        }

        const text = await res.text();
        const locLine = text.split('\n').find((line) => line.startsWith('loc='));
        const code = locLine?.slice(4).trim().toUpperCase();
        return isValidCountryCode(code) ? code : null;
    } catch {
        return null;
    }
}

async function fetchFromIpApiCo(): Promise<string | null> {
    try {
        const res = await fetch('https://ipapi.co/country_code/', {
            cache: 'no-store'
        });
        if (!res.ok) {
            return null;
        }

        const code = (await res.text()).trim().toUpperCase();
        return isValidCountryCode(code) ? code : null;
    } catch {
        return null;
    }
}

/**
 * Resolves the visitor's ISO-2 country from their public IP.
 * Edge headers work in production; localhost falls back to browser-side lookups.
 */
export async function fetchClientIpCountry(): Promise<string | null> {
    try {
        const apiRes = await fetch('/api/ip-country', { cache: 'no-store' });
        if (apiRes.ok) {
            const data = (await apiRes.json()) as { countryCode?: string | null };
            if (isValidCountryCode(data.countryCode)) {
                return data.countryCode.toUpperCase();
            }
        }
    } catch {
        // Fall through to public IP lookup.
    }

    return (await fetchFromCloudflareTrace()) ?? (await fetchFromIpApiCo());
}
